/** Key of header where request origin is sent */
export const ATMTS_REQUEST_ORIGIN_HEADER_NAME = "X-Atmts-Request-Origin";

/** Value of request origin header */
export const ATMTS_REQUEST_ORIGIN_HEADER_VALUE = "app.automotus.io";
